/* v479: Direct first-tap navigation for product image/title links on iOS.
   Scoped to actual product-card links; never intercept cart, buttons or scrolling. */
(function () {
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isIOS) return;
  var start = null;
  document.addEventListener('touchstart', function (event) {
    start = null;
    if (event.touches.length !== 1) return;
    var anchor = event.target.closest('.product-card-wrapper a[href*="/products/"]');
    if (!anchor || anchor.closest('button, form, .quick-add, .product-form')) return;
    start = { anchor: anchor, x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true });
  document.addEventListener('touchcancel', function () { start = null; }, { passive: true });
  document.addEventListener('touchend', function (event) {
    if (!start || event.changedTouches.length !== 1) { start = null; return; }
    var current = start;
    start = null;
    var touch = event.changedTouches[0];
    if (Math.abs(touch.clientX - current.x) > 12 || Math.abs(touch.clientY - current.y) > 12) return;
    if (!current.anchor.isConnected || !current.anchor.contains(event.target)) return;
    var href = current.anchor.href;
    if (!href || current.anchor.target === '_blank') return;
    event.preventDefault();
    window.location.assign(href);
  }, { passive: false });
})();
